import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';
import {IChannel} from '../../../../../../data/api/models';

function LinkRenderer(props: any) {
  return (
    <a href={props.href} target="_blank">
      {props.children}
    </a>
  );
}

const contentReplace = (content: string,
                        channel: IChannel) => {

  const replaceValues = {
    '{{ channel phone }}': channel.phone,
    '{{ channel opening hours }}': channel.openingHours,
    '{{ channel name }}': channel.name,
  };
  return content.replace(/{{ channel phone }}|{{ channel opening hours }}|{{ channel name }}/gi,
    (matched) => {
      return replaceValues[matched];
    });
};

const Signpost = ({signpost, channel}: { signpost?: string, channel: IChannel }) => {

  if (!signpost) {
    return null;
  }
  return (
    <div className="signpost-quote-container" id={'signpost-quote-div'}>
      <ReactMarkdown
        source={contentReplace(signpost, channel)}
        renderers={{
          link: LinkRenderer,
        }}
      />
    </div>
  );

};

export default Signpost;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoice/components/Signpost/index.tsx